import {
  DEFAULT,
  LIST,
  TITLE,
  TEXT,
  BUTTONS,
  REWARD,
  IMAGE,
  HEADER,
  IMAGES,
  USER_BILLET,
  CLOSE,
} from '../constants/components';
import Title from '../ui/title/Title';
import List from '../ui/list/List';
import Image from '../ui/image/Image';
import Reward from '../ui/reward/Reward';
import Text from '../ui/text/Text';
import Buttons from '../ui/buttons/Buttons';
import Close from '../ui/close/Close';
import Header from '../ui/header/Header';
import Images from '../ui/images/Images';
import UserBillet from '../../../features/userBillet';

export const components = {
  [DEFAULT]: ({ children }) => children,
  [TITLE]: Title,
  [LIST]: List,
  [IMAGE]: Image,
  [IMAGES]: Images,
  [REWARD]: Reward,
  [TEXT]: Text,
  [BUTTONS]: Buttons,
  [HEADER]: Header,
  [USER_BILLET]: UserBillet,
  [CLOSE]: Close,
};
